import Component from "vue-class-component";
import { Mixins, Prop } from "vue-property-decorator";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";

@Component({ name: "VideoRequestConfirm", components: { BaseAvatar, BaseButton } })
export default class VideoRequestConfirm extends Mixins(WithAuthUser) {
  @Prop({ type: Object, required: true })
  public readonly opponentUser!: UserPublicData;

  @Prop({ type: String })
  public readonly callerId!: string;

  public get price() {
    return "";
  }
}
